/**
 * Shared formatting utilities for consistent display across the app
 */

export { formatDate, formatDateLong } from '@lov/shared';

/**
 * Format currency to Indian Rupees
 */
export function formatCurrency(amount: number, currency = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Format currency with decimals
 */
export function formatCurrencyPrecise(amount: number, currency = 'INR'): string {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format financial year string with "FY " prefix for consistent display
 * e.g. "2024-25" → "FY 2024-25", "FY 2024-25" → "FY 2024-25" (idempotent)
 */
export const formatFinancialYear = (fy: string): string => (fy.startsWith('FY ') ? fy : `FY ${fy}`);
